"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", {
  transform: "translate(6 5)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M11,15a4,4,0,1,1,4-4A4,4,0,0,1,11,15ZM11,8a3,3,0,1,0,3,3A3,3,0,0,0,11,8Z"
})));
module.exports = exports.default;